export default __webpack_public_path__ + "03aad296d6203fc862a05777c4bf9317.svg";